/**
 * Formats SQL query results into a MySQL-style table string.
 * @param {Object} queryResult - The query result object with `data` and `columns`.
 * @returns {string} - Formatted table string.
 */
export function formatSQLTable(queryResult) {
  if (!queryResult || !queryResult.data || !queryResult.columns) {
    return "No data available";
  }

  const { data, columns } = queryResult;

  // Handle empty result set
  if (!data.length) {
    return "Query executed successfully (0 rows returned)";
  }

  // Convert data to array of arrays for easier processing
  const rows = data.map(row => columns.map(col => String(row[col] || 'NULL')));

  // Calculate max width for each column
  const colWidths = columns.map((col, i) => 
    Math.max(
      col.length,
      ...rows.map(row => row[i].length)
    )
  );

  // Create separator row (e.g., +----+----++)
  const separator = '+' + colWidths.map(w => '-'.repeat(w + 2)).join('+') + '+';

  // Create header row
  const header = 
    '|' + 
    columns.map((col, i) => ` ${col.padEnd(colWidths[i])} `).join('|') + 
    '|';

  // Create data rows
  const dataRows = rows.map(row => 
    '|' + 
    row.map((cell, i) => ` ${cell.padEnd(colWidths[i])} `).join('|') + 
    '|'
  );

  // Combine all parts
  return [
    separator,
    header,
    separator,
    ...dataRows,
    separator
  ].join('\n');
}